import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useUserMetadata } from "../../hooks/useUserMetadata";
import UserAvatar from "../../ui/UserAvatar";
import { cn } from "@/lib/utils"

function ChatAvatar({ role, className }) {
  const { data: userMetadata } = useUserMetadata();

  if (role === "user") {
    return <UserAvatar user={userMetadata} className={cn("scale-75", className)} />;
  }
  return (
    <Avatar className={cn("scale-75", className)}>
      <AvatarImage
        src="/icons8-quill-with-ink-96.png"
        alt="Image"
        className="scale-75"
      />
      <AvatarFallback>AI</AvatarFallback>
    </Avatar>
  );
}

export default ChatAvatar;
